import { render, staticRenderFns } from "./creatorHome.vue?vue&type=template&id=22cb2b54&scoped=true"
import script from "./creatorHome.vue?vue&type=script&lang=js"
export * from "./creatorHome.vue?vue&type=script&lang=js"
import style0 from "./creatorHome.vue?vue&type=style&index=0&id=22cb2b54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22cb2b54",
  null
  
)

export default component.exports